<template>
  <text-input
    v-bind="{ required, label: showLabel, placeholder }"
    :value="value"
    @input="updateName"
    :error="$root.errorBag.name">
    {{ label }}
  </text-input>
</template>
<script>

export default {

  props: {
    value: {
      type: String|Number,
      default: ''
    },
    store: {
      type: String,
      default: '',
      required: true
    },
    mutation: {
      type: String,
      default: '',
      required: true
    },
    label: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '',
    }
  },
  
  methods: {
    updateName(value) {
      this.$store.commit(`${this.store}/${this.mutation}`, value)
    }
  },

  computed: {
    showLabel() {
      return (this.label.length > 0)
    }
  }

}
</script>